import { createTheme } from '@mui/material/styles';

/**
 * Scoped to the landing page only (wrapped around <LandingPage> itself, not
 * the app root) — strips MUI's default visual styling for the MUI component
 * types used under pages/components/LandingPageComponents, so Tailwind
 * classes are the only thing controlling appearance there. Does not affect
 * the app-wide MUI theme in src/context/ThemeContext.tsx, which Ticket
 * Management and other screens still rely on.
 */
const landingTheme = createTheme({
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          margin: 0,
          fontSize: 'inherit',
          fontWeight: 'inherit',
          lineHeight: 'inherit',
          color: 'inherit',
          fontFamily: 'inherit',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          padding: 0,
          minWidth: 0,
          borderRadius: 0,
          boxShadow: 'none',
          backgroundColor: 'transparent',
          color: 'inherit',
          fontFamily: 'inherit',
          fontSize: 'inherit',
          fontWeight: 'inherit',
          lineHeight: 'inherit',
          '&:hover': {
            backgroundColor: 'transparent',
            boxShadow: 'none',
          },
        },
      },
    },
  },
});

export default landingTheme;
